/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Ai_Provider_DescInputs */

const en_settings_ai_provider_desc = /** @type {(inputs: Settings_Ai_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All AI features are powered by Mistral, processed server-side.`)
};

const de_settings_ai_provider_desc = /** @type {(inputs: Settings_Ai_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle KI-Funktionen werden von Mistral bereitgestellt und serverseitig verarbeitet.`)
};

const fr_settings_ai_provider_desc = /** @type {(inputs: Settings_Ai_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les fonctionnalités d'IA sont alimentées par Mistral, traitées côté serveur.`)
};

const es_settings_ai_provider_desc = /** @type {(inputs: Settings_Ai_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las funciones de IA son impulsadas por Mistral, procesadas en el servidor.`)
};

const it_settings_ai_provider_desc = /** @type {(inputs: Settings_Ai_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le funzionalità AI sono alimentate da Mistral, elaborate lato server.`)
};

const nl_settings_ai_provider_desc = /** @type {(inputs: Settings_Ai_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle AI-functies worden aangedreven door Mistral, verwerkt serverzijde.`)
};

const pl_settings_ai_provider_desc = /** @type {(inputs: Settings_Ai_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie funkcje AI są zasilane przez Mistral, przetwarzane po stronie serwera.`)
};

const fi_settings_ai_provider_desc = /** @type {(inputs: Settings_Ai_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki AI-ominaisuudet toimivat Mistralin avulla, palvelimella.`)
};

const da_settings_ai_provider_desc = /** @type {(inputs: Settings_Ai_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle AI-funktioner drives af Mistral, behandlet server-side.`)
};

const sv_settings_ai_provider_desc = /** @type {(inputs: Settings_Ai_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla AI-funktioner drivs av Mistral, bearbetas serversidan.`)
};

/**
* | output |
* | --- |
* | "All AI features are powered by Mistral, processed server-side." |
*
* @param {Settings_Ai_Provider_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_ai_provider_desc = /** @type {((inputs?: Settings_Ai_Provider_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Ai_Provider_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_ai_provider_desc(inputs)
	if (locale === "fr") return fr_settings_ai_provider_desc(inputs)
	if (locale === "es") return es_settings_ai_provider_desc(inputs)
	if (locale === "it") return it_settings_ai_provider_desc(inputs)
	if (locale === "nl") return nl_settings_ai_provider_desc(inputs)
	if (locale === "pl") return pl_settings_ai_provider_desc(inputs)
	if (locale === "fi") return fi_settings_ai_provider_desc(inputs)
	if (locale === "da") return da_settings_ai_provider_desc(inputs)
	if (locale === "sv") return sv_settings_ai_provider_desc(inputs)
	return en_settings_ai_provider_desc(inputs)
});